import { rowClassForAtraso } from "@/lib/atraso";

// Grupo visual para ORDENAR (misma precedencia de colores de la Hoja de Pedidos).
export const grupoOrden = (o) => {
  const entregado = o.estado_entrega === "entregado";
  if (o.estado_facturacion === "facturado" && !(o.estado === "cancelado" || o.anulado)) return 7;
  if (o.estado === "cancelado" || o.anulado || o.estado_entrega === "danado") return 6.5;
  if (entregado) return 6;
  const depto = o.se_envia && ["departamento", "expreso"].includes(o.envio_tipo);
  if (depto && (o.col_resumen?.colocados || 0) > 0) return 5;
  if (o.se_envia) return o.envio_tipo !== "ciudad" ? 3 : 2;
  if (rowClassForAtraso(o)) return 4;
  return 1;
};

// Posición congelada: solo cambia al volver a presionar ORDENAR.
export const crearOrden = (orders) => {
  const m = new Map();
  orders.map((o, i) => [o, i]).sort((a, b) => grupoOrden(a[0]) - grupoOrden(b[0]) || a[1] - b[1]).forEach(([o], i) => m.set(o.id, i));
  return m;
};

export const aplicarOrden = (lista, orden) => (orden
  ? [...lista].sort((a, b) => (orden.has(a.id) ? orden.get(a.id) : -1) - (orden.has(b.id) ? orden.get(b.id) : -1))
  : lista);
